module.exports = __webpack_public_path__ + "media/images/lb/292-f2abcc01618febd2dbe6270a852911dc.svg";